import React, { createContext, useState, ReactNode } from 'react';
import { useContext } from 'react';
type RoleContextType = {
  role: string | null;
  setRole: (newRole: string) => void;
};

const ROLE_KEY = 'bmc_active_role';

export const RoleContext = createContext<RoleContextType | undefined>(undefined);

export const RoleProvider: React.FC<{ children: ReactNode; initialRole?: string }> = ({ children, initialRole = null }) => {
  const [role, setRoleState] = useState<string | null>(
    initialRole ?? sessionStorage.getItem(ROLE_KEY)
  );

  const setRole = (newRole: string) => {
    sessionStorage.setItem(ROLE_KEY, newRole);
    setRoleState(newRole);
  };

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
};